
import { Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LineChart, Label } from "recharts";
import { useTheme } from "@/components/theme-provider";
import { CSS_CHART_COLORS } from "@/components/analytics/constants/chartColors";

interface MonthlyLineChartProps {
  data: { month: string; amount: number; }[];
}

export const MonthlyLineChart = ({ data }: MonthlyLineChartProps) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  const chartConfig = {
    amount: { 
      color: CSS_CHART_COLORS.primary, 
      label: "Revenue" 
    },
  };

  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart
        data={data}
        margin={{ top: 20, right: 30, left: 20, bottom: 50 }}
      >
        <CartesianGrid 
          strokeDasharray="3 3" 
          stroke={CSS_CHART_COLORS.grid}
          opacity={0.4}
        />
        <XAxis 
          dataKey="month" 
          angle={-45} 
          textAnchor="end"
          height={80}
          padding={{ left: 20, right: 20 }}
          tick={{ fill: CSS_CHART_COLORS.text, fontSize: 12 }}
        />
        <YAxis 
          tickFormatter={(value) => `$${value.toLocaleString()}`}
          tick={{ fill: CSS_CHART_COLORS.text, fontSize: 12 }}
        >
          <Label 
            value="Revenue ($)" 
            angle={-90} 
            position="insideLeft" 
            style={{ textAnchor: 'middle', fill: CSS_CHART_COLORS.text }} 
          />
        </YAxis>
        <Tooltip 
          contentStyle={{ 
            backgroundColor: CSS_CHART_COLORS.background,
            border: `1px solid ${CSS_CHART_COLORS.grid}`,
            borderRadius: '0.5rem',
            color: CSS_CHART_COLORS.text
          }}
          formatter={(value: number) => [`$${value.toLocaleString()}`, 'Revenue']}
        />
        <Legend 
          wrapperStyle={{ color: CSS_CHART_COLORS.text }}
        />
        <Line
          type="monotone"
          dataKey="amount"
          name="Revenue"
          stroke={CSS_CHART_COLORS.primary}
          strokeWidth={2}
          dot={{ r: 4, fill: CSS_CHART_COLORS.primary }}
          activeDot={{ r: 8, fill: CSS_CHART_COLORS.primary }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};
